module.exports = {"CreatedAndSent":"Created And Sent","ChangeOrderSent":"Change Order Sent","Closed":"Closed","Cancelled":"Cancelled","OrderRequested":"Order Requested","ReloadRequested":"Reload Requested","Created":"Created","Revised":"Revised","EvedPayReady":"EvedPay Ready"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-rule/condition-type.json
// module id = hPWI
// module chunks = 12